import { Component, ViewChild } from '@angular/core';
import { AngularEditorComponent, AngularEditorConfig } from '@kolkov/angular-editor';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-html-editor',
  templateUrl: './html-editor.component.html',
  styleUrls: ['./html-editor.component.css'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: HtmlEditorComponent,
    multi: true
  }],
})
export class HtmlEditorComponent implements ControlValueAccessor {

  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '25rem',
    minHeight: '5rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    uploadUrl: 'uploads',
    customClasses: [ // optional
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ]
  }; 

  @ViewChild(AngularEditorComponent, { static: true }) editor: AngularEditorComponent;

  constructor() { }

  writeValue(obj: any): void {
    this.editor.writeValue(obj);
  }

  registerOnChange(fn: any): void {
    this.editor.registerOnChange(fn);
  }

  registerOnTouched(fn: any): void {
    this.editor.registerOnTouched(fn);
  }
  
  insertHtml(html: string) {
      this.editor.textArea.nativeElement.focus();
     document.execCommand('insertHTML', false, '*|' + html + '|*');
  } 
}
